import Vue from 'vue';
import Vuex from 'vuex';

import { CaslVuex } from '@/casl';
import { AuthVuex, AuthCache } from '@/store/plugins';

import auth from '@/store/modules/auth';
import notifications from '@/store/modules/notifications';
import orders from '@/store/modules/orders';
import attachments from '@/store/modules/attachments';
import contractors from '@/store/modules/contractors';
import customers from '@/store/modules/customers';
import objects from '@/store/modules/objects';
import settings from '@/store/modules/settings';
import services from '@/store/modules/services';
import firebase from '@/store/modules/firebase';
import partners from '@/store/modules/partners';

Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: [
    CaslVuex,
    AuthCache,
    AuthVuex,
  ],
  modules: {
    auth,
    notifications,
    orders,
    attachments,
    contractors,
    customers,
    objects,
    settings,
    services,
    firebase,
    partners,
  },
});

export default store;
